var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPoolWater = function SvgPoolWater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.348 7.348A3.75 3.75 0 0 1 28.75 10a1.25 1.25 0 1 0 2.5 0A6.25 6.25 0 0 0 20 6.25 6.25 6.25 0 0 0 8.75 10a1.25 1.25 0 1 0 2.5 0 3.75 3.75 0 0 1 7.5 0v15.417h-2.5v-7.084a4.584 4.584 0 0 0-9.167 0 1.25 1.25 0 1 0 2.5 0 2.083 2.083 0 0 1 4.167 0v7.084H5c-.69 0-1.25.56-1.25 1.25V30A6.25 6.25 0 0 0 10 36.25h20A6.25 6.25 0 0 0 36.25 30v-3.333c0-.69-.56-1.25-1.25-1.25h-8.75v-7.084a2.083 2.083 0 0 1 4.167 0 1.25 1.25 0 1 0 2.5 0 4.583 4.583 0 0 0-9.167 0v7.084h-2.5V10a3.75 3.75 0 0 1 1.098-2.652M6.25 30v-2.083h27.5V30A3.75 3.75 0 0 1 30 33.75H10A3.75 3.75 0 0 1 6.25 30",
    clipRule: "evenodd"
  })));
};
export default SvgPoolWater;